import React, { useState } from "react";
import PrimaryButton from '../../components/Layout/PrimaryButton';
import FileInput from '../../components/Layout/FileInput';
import loaderIcon from '../../assets/loader.svg';
import './ModalAttach.scss';

import expensesService from '../../services/expenses';
import Utils from '../../components/Utils/Utils';

import { PDFDocument } from 'pdf-lib';

function ModalAttach({ onCloseModal, url, mtId, dueDate, companies, companyID, onUploadSuccess, expenseID }) {
  const initialFields = { 
    pdfPath: { value: 0, valid: true, validationMessage: '' }
  };
  const [fields, setFields] = useState({ ...initialFields });
  const [successForm, setSuccessForm] = useState(false);
  const [loading, setLoader] = useState(false);

  let errorLog = '';

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    const name = String(file.name).split(".").slice(0, -1).join(".");
    const date = new Date();
  
    setFields((prevFields) => ({
      ...prevFields,  
      [fieldName]: {
        ...prevFields[fieldName],
        value: {
          file: file,
          filename: file.name,
          name,
          displayDate: date,
          date: date.toISOString(),
        }
      }
    }));
  };
  
  const handleSubmit = async (e) => {
    
    e.preventDefault();
    const formData = {};
    const filesUpload = [];
    if (fields.pdfPath.value !== 0) {
      filesUpload.push({
        type: 'pdfPath',
        objFile: fields.pdfPath.value
      });
    }

    const pdfFiles = [];

    // const uploadInfoArray = [];
    setLoader(true);
    errorLog = '';

    try {
      if (url && url.includes('.pdf')) {
        const existingPdfBuffer = await Utils.downloadExistingPdf(url);
        const existingPdfFile = new File([existingPdfBuffer], 'existente.pdf', { type: 'application/pdf' });
        pdfFiles.push(existingPdfFile);
      }
    } catch (err) {
      setLoader(false);
      setSuccessForm(false);
      errorLog = "Erro ao baixar o arquivo existente. Verifique o link ou tente novamente.";
      return; // interrompe o processo
    }
    
    const file = filesUpload[0].objFile.file;
    const extension = file.name.split(".").pop().toLowerCase();
    let fileToUse = file;
    
    if (!["pdf"].includes(extension)) {
      const pdfBytes = await Utils.convertImageToPdf(file);
      fileToUse = new File([pdfBytes], file.name.replace(/\.[^.]+$/, ".pdf"), {
        type: "application/pdf",
      });
    }
    pdfFiles.push(fileToUse);
  

    // Junta os arquivos PDF em um único arquivo
    const mergedPdfFile = await Utils.mergePDFs(pdfFiles);

    // Faz o upload do arquivo único para a S3
    const uploadInfo = await Utils.uploadFile({ file: mergedPdfFile });

    setLoader(false);
    setSuccessForm(true);
    onUploadSuccess(uploadInfo, expenseID);
  };

  
  return (
    <div className='modal-attach'>
      <div className="inner-content" style={{maxWidth: '700px'}}>
        <>
          <h1>{ url && url.includes('.pdf') ? 'Anexar arquivo' : 'Vincular PDF' }</h1>
          <button className="btn-close" style={{border: '2px solid #fff', top: '-10px', right: '-10px' }} onClick={() => onCloseModal(false)}>X</button>
          {
            !successForm && !loading ? (
              <div className="wrapper-form">
                <h2>
                  { errorLog }  
                </h2>
                <label>
                  <FileInput tabIndex={1} defaultValue={fields.pdfPath.value} name="pdfPath" onChange={(e) => handleFileChange(e, 'pdfPath')} />
                </label>
                <PrimaryButton fullWidth onClick={handleSubmit} tabIndex={11}>Salvar</PrimaryButton>
              </div>
            ) : loading ? (
              <img className="loader" width={100} height={100} src={loaderIcon} alt="Carregando..." />
            ) : (
              <div className="wrapper-form">
                <h2>
                  { url && url.includes('.pdf') ? 'Arquivo anexado com sucesso!' : 'Arquivo vinculado com sucesso!' }  
                </h2>
              </div>
            )
          }
        </>
      </div>
    </div>
  );
}

export default ModalAttach;
